const TRADES = [
  "Electricians", "Mechanics", "Plumbers", "Builders", "Cleaning Companies",
  "Barbers", "Beauty Businesses", "Care Providers", "Consultants", "Local Services",
];

export default function Marquee() {
  const row = [...TRADES, ...TRADES];
  return (
    <div data-testid="trades-marquee" className="border-y border-sky-500/10 bg-navy-900/60 overflow-hidden py-5" aria-hidden="true">
      <div className="flex w-max animate-marquee gap-0">
        {row.map((t, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-heading font-bold text-sm sm:text-base uppercase tracking-[0.18em] text-slate-500 px-6">{t}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-sky-500/50 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
